import styled from '@emotion/styled';
import { SPACER } from 'radiance-ui/lib/constants';

export const ProductContainer = styled.li<{ size: number }>`
  min-width: ${({ size }) => (size <= 2 ? '292px;' : '180px')};
  max-width: ${({ size }) => (size <= 2 ? '343px' : '180px')};
  padding: ${SPACER.xsmall};

  & + & {
    margin-left: ${SPACER.medium};
  }
`;

export const ImageContainer = styled.div`
  margin-bottom: 12px;
`;

export const ProductName = styled.h3`
  font-size: 20px;
  font-weight: 700;
  line-height: 150%;
  margin-bottom: ${SPACER.small};
`;

export const ProductPrice = styled.div`
  font-size: 16px;
  line-height: 150%;
  margin-bottom: ${SPACER.medium};
`;

export const ProductBody = styled.p`
  margin-bottom: ${SPACER.small};
`;

export const ProductTreatmentContainer = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
`;

export const ProductTreatment = styled.li`
  font-size: 12px;
  font-weight: 700;
  line-height: 150%;
  background-color: #ff824f;
  padding: 1px 5px;
`;

export const Disclaimer = styled.small`
  font-size: 14px;
  line-height: 140%;
  margin-top: ${SPACER.medium};
`;
